import {Controller} from "stimulus";

// The license application's "Email a notice" form. Each notice type has its
// own recipient list (a contact may opt out of one notice and not the other),
// so only the chosen notice's list shows; the others are disabled as well as
// hidden, which keeps their checkboxes out of the submitted form. The notice
// is the checked notice_type radio, or the hidden notice_type field when the
// application offers only one. Send stays disabled until a recipient in the
// shown list is checked or an address is typed, and the hint saying so shows
// while it is.
export default class extends Controller {
    static targets = ["recipients", "additional", "send", "hint"];

    connect() {
        this.refresh();
    }

    refresh() {
        const noticeType = this.noticeType();
        this.recipientsTargets.forEach((list) => {
            const chosen = list.dataset.noticeType === noticeType;
            list.hidden = !chosen;
            list.disabled = !chosen;
        });
        const ready = this.hasRecipient();
        if (this.hasSendTarget) this.sendTarget.disabled = !ready;
        if (this.hasHintTarget) this.hintTarget.hidden = ready;
    }

    noticeType() {
        const field = this.element.querySelector("input[name=notice_type]:checked") ||
            this.element.querySelector("input[type=hidden][name=notice_type]");
        return field ? field.value : null;
    }

    hasRecipient() {
        const chosen = this.recipientsTargets.some((list) =>
            !list.disabled && list.querySelector("input[type=checkbox]:checked:not(:disabled)"));
        const typed = this.hasAdditionalTarget && this.additionalTarget.value.trim().length > 0;
        return chosen || typed;
    }
}
